import o from "./highrise1477.mjs";
import r from "./highrise1340.mjs";
function c(t) {
  return o(t, r(t));
}
export {
  c as default
};
